<template>
  <div class="flex justify-between border-b border-grey-300 h-12">
    <div class="w-64 flex-no-shrink py-2 px-4 whitespace-no-wrap self-center">
      {{ item.text }}
    </div>
    <div class="w-full flex justify-end">
      <div
        v-for="(entry, index) in entries"
        :key="entry.id"
        :class="{
          'hidden': !entry.requires_monitor_feedback,
          'border-l-4 border-grey-300 flex relative items-center justify-center': entry.requires_monitor_feedback
        }"
      >
        <template v-if="entry.requires_monitor_feedback">
          <div
            class="h-full w-12 p-1"
            :class="{
              'bg-primary-100':
                entry.partner_can_provide_feedback &&
                entry.partner_status === null,
              'bg-grey-200': index > activeIndex
            }"
          >
            <progress-report-marker
              v-if="entry.partner_can_provide_feedback || (entry.partner_status !== null || entry.partner_feedback)"
              :key="entry.id + '_partner'"
              :entry="entry"
              :item="item"
              :can-edit="canEdit"
              @progress:save="$emit('progress:save', $event)"
            />
          </div>
          <div
            v-if="entry.requires_monitor_feedback"
            class="w-12 p-1 h-full border-l border-grey-300"
            :class="{
              'bg-primary-100': isMonitor && entry.monitor_can_provide_feedback,
              'bg-grey-200':
                (!entry.monitor_can_provide_feedback && index > activeIndex) ||
                (!isMonitor && !entry.monitor_monitoring_completed)
            }"
          >
            <progress-report-marker
              v-if="(isMonitor && entry.monitor_can_provide_feedback) || entry.monitor_monitoring_completed"
              :key="entry.id + '_monitor'"
              :can-edit="isMonitor"
              :entry="entry"
              type="monitor"
              :item="item"
              @progress:save="update"
            />
          </div>
          <div
            v-if="entry.requires_msp_feedback"
            class="w-12 p-1 h-full border-l border-grey-300"
            :class="{
              'bg-primary-100': isMsp && entry.msp_can_provide_feedback,
              'bg-grey-200': (!entry.msp_can_provide_feedback && index > activeIndex) || (!isMsp && !entry.msp_monitoring_completed),
            }"
          >
            <progress-report-marker
              v-if="(isMsp && entry.msp_can_provide_feedback) || entry.msp_monitoring_completed"
              :key="entry.id + '_msp'"
              :can-edit="isMsp"
              :entry="entry"
              type="msp"
              :item="item"
              @progress:save="update"
            />
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProgressReportRow",
  props: {
    isMsp: {
      type: Boolean,
      default: false
    },
    isMonitor: {
      type: Boolean,
      default: false
    },
    canEdit: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      required: true
    },
    entries: {
      type: Array,
      required: true
    }
  },
  computed: {
    activeIndex() {
      return this.entries.findIndex(
        interval => interval.partner_can_provide_feedback
      );
    }
  },
  methods: {
    update(data) {
      this.$emit("progress:save", data);
    }
  }
};
</script>
